import React from 'react';
import styled from 'styled-components';
import { useRecoilState } from 'recoil';
import { mockupState, MockupState, SCALE_STATE } from '../../../Recoil/RecoilState';
import produce from 'immer';
import { transform } from 'framer-motion';
import { screenSize } from '../../../stylesGlobal/Variables';
import { sendEvent } from '../../../utils/Events';
import Input from '../Input/index';

const ScaleImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--color-white);
  margin-right: 6%;
  position: relative;

  .scaleImage__label {
    font-size: 1.3rem;
    margin-right: 1.5rem;
    font-weight: 500;
  }

  .scaleImage__Container {
    display: flex;
    padding: 0 1rem;
  }

  .scaleImage_symbol {
    font-size: 1.2rem;
    font-weight: 500;
  }

  @media (min-width: ${screenSize.size_m}) {
    margin-right: 7%;
  }
  @media (min-width: ${screenSize.size_xl}) {
    margin-right: 8%;
  }
`;

const ScaleImage = () => {
  const [mockupGeneralState, setMockupGeneralState] = useRecoilState(mockupState);

  const maxWidth =
    mockupGeneralState.mockup.images[mockupGeneralState.selectedImage.id].defaultScale * 3;
  const minWidth =
    mockupGeneralState.mockup.images[mockupGeneralState.selectedImage.id].defaultScale / 3;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const scaleValue = parseInt(event.currentTarget.value, 10);
    const newValue = transform(scaleValue, [0, 100], [minWidth, maxWidth]);
    setMockupGeneralState(
      produce((draftState: MockupState) => {
        draftState.mockup.images[draftState.selectedImage.id].imageScale = newValue;
        draftState.mockup.scaleState = SCALE_STATE.changeing;
      }),
    );
  };

  const handleMouseUp = (_event: React.MouseEvent<HTMLInputElement, MouseEvent>) => {
    sendEvent('MG - Toolbar', 'resize');
    setMockupGeneralState(
      produce((draftState: MockupState) => {
        // if (draftState.userImage.base64 !== "") {
        //     draftState.events.push(EventTypes.scaleImage)
        // }
        draftState.mockup.scaleState = SCALE_STATE.stop;
      }),
    );
  };

  const rangeValue =
    transform(
      mockupGeneralState.mockup.images[mockupGeneralState.selectedImage.id].imageScale
        ? mockupGeneralState.mockup.images[mockupGeneralState.selectedImage.id].imageScale
        : mockupGeneralState.mockup.images[mockupGeneralState.selectedImage.id].defaultScale,
      [minWidth, maxWidth],
      [0, 100],
    ) || 0;
  return (
    <ScaleImageWrapper>
      <p className="scaleImage__label">size</p>
      <span className="scaleImage_symbol">-</span>
      <div className="scaleImage__Container">
        <Input.Range value={rangeValue} onChange={handleChange} onMouseUp={handleMouseUp} />
      </div>
      <span className="scaleImage_symbol">+</span>
    </ScaleImageWrapper>
  );
};

export default ScaleImage;
